/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/function-component-definition */
import { FC, memo } from "react";
import { FormikProps } from "formik";
import { CreateLeadsDetails } from "src/helpers/FormDetails/CreateDetails/interfaces";
import { fileInitialValue } from "src/helpers/FormDetails/CreateDetails";
import { Button } from "@mui/material";
import CustomBoxModal from "../CustomModalBox";
import UploadDocumentWithType from "./UploadDocumentWithType";
import AddMoreButton from "../AddMoreButton";

interface Props {
  className?: string;
  multipleUploads?: boolean;
  formik: FormikProps<CreateLeadsDetails>;
  onClose: () => void;
  onSave: () => void;
}

const CustomDocumentUpload: FC<Props> = ({ formik, onClose, onSave }) => {
  const handleAddMoreClick = () => {
    formik?.setFieldValue("files", [...(formik.values.files || []), fileInitialValue]);
  };
  return (
    <CustomBoxModal onClose={onClose}>
      <div className="text-center">
        <div className="!rounded-lg px-10 py-8 !text-sm space-y-5">
          <h1 className="font-bold text-lg !text-center">UPLOAD DOCUMENTS</h1>
          {formik?.values?.files?.map((_file, index) => (
            <UploadDocumentWithType
              key={index}
              formik={formik}
              docIndex={index}
              acceptedFiles={[".pdf", ".jpg", ".jpeg", ".wav"]}
              maxFileSize={5 * 1024 * 1024}
            />
          ))}
        </div>
        {formik?.values?.files?.length! < 7 && (
          <div className="flex justify-center">
            <AddMoreButton label="Add More (Max.7)" onClick={handleAddMoreClick} />
          </div>
        )}
        <div className="!mx-auto">
          <Button
            variant="outlined"
            classes={{ outlined: "!rounded-lg !mx-auto" }}
            onClick={onSave}
            className="!text-black !uppercase h-13 w-37.5 rounded-lg !mr-10 !mt-5 !text-center"
          >
            SAVE
          </Button>
        </div>
      </div>
    </CustomBoxModal>
  );
};

CustomDocumentUpload.defaultProps = {
  className: "",
  multipleUploads: false
};

export default memo(CustomDocumentUpload);
